class CaptchaError extends Error {
  constructor(message, name = 'CaptchaError') {
    super(message)
    this.name = name
    this.message = message
  }
}

export class CaptchaTokenError extends CaptchaError {
  constructor(action, provider) {
    const baseMessage = `Failed to get captcha token for action: ${action}`
    super(baseMessage, 'CaptchaTokenError')
    this.action = action
    this.provider = provider
    this.message = `${baseMessage} | Details: ${
      JSON.stringify(this.getDetails())
    }`
  }

  getDetails() {
    return {
      provider: this.provider,
      action: this.action,
    }
  }
}
